import { useMemo } from 'react'
import uniq from 'lodash/uniq'
import { trpc } from '@klear/ui/lib/trpc'

export function useLinkedPayments(payableIds: number[]) {
  const ids = useMemo(() => uniq(payableIds.filter((id): id is number => !!id)), [payableIds])
  const { data, isLoading, error, refetch } = trpc.payable.linkedExecutionStatus.useQuery(
    { payableIds: ids },
    { enabled: ids.length > 0 }
  )

  const byPayableId = useMemo(() => new Map((data ?? []).map((status) => [status.payableId, status])), [data])

  return { linkedPayments: byPayableId, isLoading, error, refetch }
}

export function useLinkedPayment(payableId?: number) {
  const { linkedPayments, isLoading, error } = useLinkedPayments(payableId ? [payableId] : [])
  return {
    linkedPayment: payableId ? linkedPayments.get(payableId) : undefined,
    isLoading,
    error
  }
}
